import { render } from "./ViewPerformanceManagement.vue?vue&type=template&id=aeb621b0&scoped=true"
import script from "./ViewPerformanceManagement.vue?vue&type=script&lang=js"
export * from "./ViewPerformanceManagement.vue?vue&type=script&lang=js"

import "./ViewPerformanceManagement.vue?vue&type=style&index=0&id=aeb621b0&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb621b0"]])

export default __exports__